import {
  Header1,
  Header2,
  Header3,
} from "../FlashPCBMarkdown/FlashPCBMarkdownStyles";
import { Container, Header, Paragraph } from "./AboutUsStyles";

const AboutUs = () => {
  return (
    <Container>
      <Header>
        <Header1>About FlashPCB</Header1>
      </Header>

      <div>
        <Header3>
          We are a team of 10 full-time employees with diverse technical
          backgrounds.
        </Header3>
        <Header2>Careers</Header2>
        <Paragraph>
          We are currently looking to fill the following roles:
        </Paragraph>
        <Paragraph>
          <a
            href={"https://www.linkedin.com/jobs/view/4478549776/"}
            target={"_blank"}
          >
            Electrical Sales Engineer
          </a>
        </Paragraph>
        <Header2>Our mission</Header2>
        <Paragraph>
          At FlashPCB, our mission is to make our customers feel{" "}
          <span>relieved</span> when they order their PCBAs because our
          customers <span>trust</span> our service to{" "}
          <span>consistently deliver high quality PCBAs on time</span>. We also
          want to build a <span>positive solution-oriented workplace</span> with
          everyone striving to improve our services and grow the business.
        </Paragraph>
        <Header2>Our values</Header2>
        <Paragraph>
          <span className="emphasized">
            Speed and quality through automation –{" "}
          </span>
          We build smart software driven systems that eliminate delays, reduce
          errors, and deliver fast, predictable outcomes.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">
            Delivery dates actually mean something –
          </span>{" "}
          We will do everything in power to deliver each board on time because
          our delivery dates actually mean something.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">We care about quality – </span>Every
          board we ship meets the IPC standards and will correct anything less
          than that.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">Earn long-term trust – </span>We aim to
          grow with our customers, helping them scale from quick-turn protos to
          reliable, repeatable production.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">
            Clear direct and solution driven communication –{" "}
          </span>
          We’re transparent about lead times, pricing, and issues and will
          always try to present the customer with a solution instead of just a
          problem.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">A can-do culture – </span>We take pride
          in finding solutions and going the extra mile to get boards built
          right
          {
            "and on time. We want to be the solution to our customers' problems, not the other way around."
          }
        </Paragraph>
        <Paragraph>
          <span className="emphasized">Customer-focused design – </span>Our
          tools and processes are built with real customer needs in mind.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">Relentless improvement – </span>We
          continuously refine our tools, processes, and people to serve our
          customers better every day
        </Paragraph>
        <Header2>About our founders</Header2>
        <Paragraph>
          <span className="emphasized">Thomas Castner</span>, CEO & Co-founder.
          Dual Degree from University of Pennsylvania in mechanical engineering
          and finance and an MS in mechanical engineering from Carnegie Mellon
          University. Tom has 10+ years of technical experience in PCB design
          and prototyping, design for manufacturing, and team management. He was
          Director of Hardware at Allevi, a 3D bioprinting company recently sold
          to 3D Systems. He designed a particle analysis instrument for Halo
          Labs (formerly Optofluidics) that was funded by a Phase I and II SBIR
          grant. He designed portable battery packs for Gridless Power.
          Additionally, he consulted on Osciflex’s VTE mitigation device, funded
          by an NSF Phase I SBIR grant.
        </Paragraph>
        <Paragraph>
          <span className="emphasized">George Woskob</span>, CTO & Co-founder,
          BA in economics and music from University of Chicago and has a
          certificate from Stanford’s Artificial Intelligence Graduate Program.
          George has 10+ y ears of experience in software development and is
          skilled in product development, AI, and testing methods. He was a
          software engineer for Covera Health which uses data and AI to assure
          quality care in radiology. At ThoughtWorks he built and launched
          products for companies across a broad spectrum of industries.
        </Paragraph>
      </div>
    </Container>
  );
};

export default AboutUs;
